export default "__VITE_ASSET__lufCyKLC__"